import { View } from 'react-native';
import { colors } from '../../../theme/colors';

interface CalendarNowMarkerProps {
  /** 0-1 position within the column's height (see getNowLineRatio). */
  ratio: number;
  testID?: string;
}

// A dot + a short, bounded-length tick — never a rail spanning the full
// column width. The design-system guardrail (scanEdgeStripes) correctly
// flags a thin absolutely-positioned box stretching left:0/right:0 with a
// fill colour as the retired "edge stripe" pattern, even for a legitimate
// time-marker, so this stays bounded on purpose. Same "dot/icon/Badge, never
// hue alone" language as CalendarMonthDayCell's "Today" Badge. Shared by
// CalendarDayTimeline (Unit 4) and CalendarWeekDayColumn (Unit 5) so both
// draw the exact same marker.
export function CalendarNowMarker({ ratio, testID }: Readonly<CalendarNowMarkerProps>) {
  return (
    <View
      testID={testID}
      pointerEvents="none"
      style={{ position: 'absolute', top: `${ratio * 100}%`, left: 0 }}
    >
      <View
        style={{
          position: 'absolute',
          left: -4,
          top: -4,
          width: 8,
          height: 8,
          borderRadius: 4,
          backgroundColor: colors.status.error.main,
        }}
      />
      <View style={{ width: 24, height: 2, backgroundColor: colors.status.error.main }} />
    </View>
  );
}
